import { render, staticRenderFns } from "./LaboratoryEdit.vue?vue&type=template&id=a9213e1e"
import script from "./LaboratoryEdit.vue?vue&type=script&lang=js"
export * from "./LaboratoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports